import { useBundleLoader } from "./bundle-loader";
import $ from "jquery";
import "bootstrap";
import { useVue } from "./vue";
import { FixedHelp } from "../app/components/fixed-help";
import { ModalVideo } from "../app/components/modal-video";
import { useSelectBox } from "../app/shared/components/select-box/use-select-box";
import { BenefitSlider } from "../app/homepage/benefit-slider";
import { Footer } from "./footer";
import { useLazyLoading } from "../app/components/use-lazy-loading";
import { initChat, registerChatToWindow } from "../app/components/chat";
import { initMobileAppFeatures } from "@sazka/mobile-apps/mobile-app-integration";
import { documentReady } from "@sazka/utils/document-ready";
import { useGdpr } from "@/account/composables/use-gdpr";

document.ready = documentReady;

window.dataLayer = window.dataLayer || [];

// register tmp global types for Ticket Check APP
(window as any).$ = $;
(window as any).jQuery = $;

useBundleLoader();
useVue();
initChat();

$(() => {
    FixedHelp.init();
    ModalVideo.init();
    BenefitSlider.init();
    Footer.init();
    useLazyLoading();
    useSelectBox();
    registerChatToWindow();
    useGdpr().init();
    initMobileAppFeatures();
});
